module.exports = ".sebm-google-map-container {\n  width: 100%;\n  height: 300px; }\n"